import {getSystem} from '@/utils/site'
const staticDomains = {
	ept: '//static.joybuy.com/static-e/release/',
	th: '//jshop-static.jd.co.th/release/',
	EJSHOP:'//static.360buyimg.com/static-zgb/release/',
	id:'//ejshop-dec-static.jd.id/release/'
}

export default function () {
    var sys=getSystem()
    __webpack_public_path__=staticDomains[sys]
}